<template>
  <div class="text-layer__root">
    <div class="d-flex justify-center align-center" style="width: 100%; height: 100%">
      <h1 class="ml4" style="width: 100%">
        <!-- <span class="letters letters-1">만수르님</span>
                <span class="letters letters-2">후원</span>
                <span class="letters letters-3">감사합니다!</span> -->
      </h1>
    </div>
  </div>
</template>

<script>
import { createTimeline } from "animejs";

const animeItems = [{ text: "a", style: { color: "red" } }];

export default {
  methods: {
    play(animeItems) {
      this.stop();

      const $target = this.$el.querySelector(".ml4");
      animeItems.forEach((item, i) => {
        const { text, style } = item;

        const $span = document.createElement("span");
        $span.classList.add("letters", `letters-${i + 1}`);

        $span.style.position = "absolute";
        $span.style.margin = "auto";
        $span.style.left = "0";
        // $span.style.top = "0.3em";
        $span.style.top = "1em";
        $span.style.right = "0";
        $span.style.opacity = "0";

        // text style
        const { color } = style || {};
        $span.style.color = color || "white";
        $span.style.fontSize = "2em";
        $span.style.fontFamily = "Ownglyph_meetme-Rg";
        $span.style.webkitTextStroke = "1px black";

        $span.style.textAlign = "center";

        $span.textContent = text;
        $target.appendChild($span);
      });

      var ml4 = {};
      ml4.opacityIn = [0, 1];
      ml4.scaleIn = [0.2, 1];
      ml4.scaleOut = 3;
      ml4.durationIn = 400;
      ml4.durationOut = 200;
      ml4.delay = 800;
      createTimeline({ loop: false })
        .add(".ml4 .letters-1", {
                    opacity: ml4.opacityIn,
          scale: ml4.scaleIn,
          duration: ml4.durationIn,
        })
        .add(".ml4 .letters-1", {
                    opacity: 0,
          scale: ml4.scaleOut,
          duration: ml4.durationOut,
          ease: "inExpo",
          delay: ml4.delay,
        })
        .add(".ml4 .letters-2", {
                    opacity: ml4.opacityIn,
          scale: ml4.scaleIn,
          duration: ml4.durationIn,
        })
        .add(".ml4 .letters-2", {
                    opacity: 0,
          scale: ml4.scaleOut,
          duration: ml4.durationOut,
          ease: "inExpo",
          delay: ml4.delay,
        })
        .add(".ml4 .letters-3", {
                    opacity: ml4.opacityIn,
          scale: ml4.scaleIn,
          duration: ml4.durationIn,
        })
        .add(".ml4 .letters-3", {
                    opacity: 0,
          scale: ml4.scaleOut,
          duration: ml4.durationOut,
          ease: "inExpo",
          delay: ml4.delay,
        });
    },
    stop() {
      //remove all children
      const $target = this.$el.querySelector(".ml4");
      while ($target.firstChild) {
        $target.removeChild($target.firstChild);
      }
    },
  },
};
</script>

<style scoped>
.text-layer__root {
  position: absolute;

  width: 100%;
  height: 100%;
}

.ml4 {
  position: relative;
  font-weight: 900;
  font-size: 2em;
}
.ml4 .letters {
  position: absolute;
  margin: auto;
  left: 0;
  top: 0.3em;
  right: 0;
  opacity: 0;
  color: white;
}
</style>
